import dayjs from 'dayjs'
import { z } from 'zod'

export const dateTimeStringSchema = z.string().refine((value) => dayjs(value).isValid(), '日期时间格式不正确')

export const creatorListQueryShape = {
  creatorMemberId: z.number().int().positive().optional(),
  createdFrom: dateTimeStringSchema.optional(),
  createdTo: dateTimeStringSchema.optional()
} as const

export const createdAtSortQueryShape = {
  sortField: z.enum(['createdAt']).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional()
} as const
